import {Breadcrumb, useSetBreadcrumbs} from '@therms/react-modules'
import {Route, Switch} from 'react-router-dom'
import {STATS_ROUTES} from '../constants'
import {StatsIndexScreen} from './screens'

const rootCrumb = (
  <Breadcrumb key="supports-root-crumb" link={STATS_ROUTES.__ROOT__}>
    Stats
  </Breadcrumb>
)

function StatsIndexRoute() {
  useSetBreadcrumbs([rootCrumb])
  return <StatsIndexScreen />
}

function StatsRoutes() {
  return (
    <Switch>
      <Route component={StatsIndexRoute} />
    </Switch>
  )
}

// used for code-splitting
// eslint-disable-next-line import-x/no-default-export
export default StatsRoutes
export {StatsRoutes}
